// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2sV4y","outlined":"styles_outlined__22NIh","map":"styles_map__2RSVV","noContent":"styles_noContent__2REeC"};